import type { SuggestedNextStepsBlock } from '@netsuite-ai/types';

interface Props {
  block: SuggestedNextStepsBlock;
  onPick?: (prompt: string) => void;
}

export function SuggestedNextSteps({ block, onPick }: Props) {
  if (!block.suggestions?.length) return null;
  return (
    <div className="mt-3">
      <p className="text-ink/50 mb-1.5 text-xs font-semibold tracking-wide uppercase">
        Suggested next steps
      </p>
      <div className="flex flex-col gap-1.5">
        {block.suggestions.map((s, i) => (
          <button
            key={i}
            type="button"
            onClick={() => onPick?.(s.prompt)}
            disabled={!onPick}
            title={s.prompt}
            className="border-ink/10 text-ink/80 hover:border-ink/20 hover:bg-ink/5 group flex items-start gap-2 rounded-md border px-3 py-2 text-left text-sm transition-colors disabled:opacity-50"
          >
            <span className="bg-ink/5 text-ink/50 group-hover:bg-ink/10 mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-xs font-medium">
              {i + 1}
            </span>
            <span>
              <span className="text-ink font-medium">{s.label}</span>
              {s.detail && <span className="text-ink/60"> — {s.detail}</span>}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
